import { cn } from "@/lib/utils/helpers"
import tabStyles from "@/features/company/styles/companyInfoTab.module.css"
import { usesTransferWizardCardLayout } from "../../utils/transferPropertyCompanyWizard"
import type { TransferPropertyInfoTabProps } from "../../types"
import { TransferCompanyPropertyListSection } from "./propertyInfo/TransferCompanyPropertyListSection"
import { TransferPropertyCompanyTransferRow } from "./propertyInfo/TransferPropertyCompanyTransferRow"
import { TransferPropertyMergeResidentRow } from "./propertyInfo/TransferPropertyMergeResidentRow"
import { TransferPropertySplitAddressSection } from "./propertyInfo/TransferPropertySplitAddressSection"
import { TransferPropertySplitHeaderRow } from "./propertyInfo/TransferPropertySplitHeaderRow"
import { TransferPropertySplitPaymentsSection } from "./propertyInfo/TransferPropertySplitPaymentsSection"
import { TransferEmailDomainSection } from "./propertyInfo/TransferEmailDomainSection"
import { TransferPropertyStandardPaymentsSection } from "./propertyInfo/TransferPropertyStandardPaymentsSection"

export function TransferPropertyInfoTab({ ctx }: TransferPropertyInfoTabProps) {
  const { selectedTab, fragment, showPayments, allProperty } = ctx
  if (selectedTab !== "propertyinfo" || !fragment) return null

  const useCardLayout = usesTransferWizardCardLayout(fragment)

  return (
    <form
      data-testid="transfer-process-property-info-form"
      className={cn(
        useCardLayout ? tabStyles.tabContent : "space-y-6",
        "animate-in fade-in duration-300",
      )}
      onSubmit={(e) => e.preventDefault()}
    >
      {!["transfer_resident", "merge_property", "split_property"].includes(fragment) ? (
        <TransferPropertyCompanyTransferRow ctx={ctx} />
      ) : null}

      {["transfer_resident", "merge_property"].includes(fragment) ? (
        <TransferPropertyMergeResidentRow ctx={ctx} />
      ) : null}

      {fragment === "split_property" ? <TransferPropertySplitHeaderRow ctx={ctx} /> : null}

      <TransferEmailDomainSection ctx={ctx} />

      {showPayments && fragment !== "split_property" ? (
        <TransferPropertyStandardPaymentsSection ctx={ctx} />
      ) : null}

      {fragment === "split_property" ? <TransferPropertySplitAddressSection ctx={ctx} /> : null}

      {showPayments && fragment === "split_property" ? (
        <TransferPropertySplitPaymentsSection ctx={ctx} />
      ) : null}

      {fragment === "transfer_company" && allProperty.length > 0 ? (
        <TransferCompanyPropertyListSection ctx={ctx} />
      ) : null}
    </form>
  )
}
